import Config from "@skin_config";
import { UPPER_SCREEN } from "@common/actionTypes";
import { SetTerminalPopupLauncher } from "../actions/terminal";
import { POPUPS } from "@common/constants/popups";
import {
	LOGIN_ADMIN,
	SET_LANGUAGE,
	CASHOUT_MONEY,
	PARTIAL_CASHOUT_MONEY,
	CASHOUT_MONEY_CASH,
	CASHOUT_CLIENT_MONEY,
	SET_BALANCE,
	PRINT_TICKET,
	PRINT_CLIENT_TICKET,
	RESET_UI_BY_IDLE_TIMER,
	TITO_ACCEPT_BET,
	TITO_CASHOUT_BET,
	ADD_TO_BALANCE,
	TERMINAL_ERROR,
	SEND_LOGS,
	TITO_ACCEPT_CASHOUT,
	LOCK_TERMINAL,
	UNLOCK_TERMINAL,
	HIDE_TERMINAL_ERROR,
	SET_TAX,
	USER_DID_LOGIN,
	USER_DID_LOGOUT,
	MOUSE_MOVE_POSITION,
	PRINT_LOTTERY_TICKET,
	REGISTER_MODE,
	CONFIRM_REGISTRATION_NEW_CARD,
	UPDATE_PLAYER_CARD_ID,
	PAY_CASINO_LOTTERY_WIN_TICKET,
	PRINT_BOOKING_TICKET,
	GET_SUPERBET_TICKET_BY_ID,
	SET_SUPERBET_ID,
	REJECT_SUPERBET,
	CASINO_GAMES_OPENED,
	RFID_REGISTER_MODE,
	CASHOUT_MONEY_WITH_FEE,
	DEPOSIT,
	DEPOSIT_TO_CLIENT_ACCOUNT,
	PRINT_BET_BUILDER_TICKET,
	ADMIN_USER_COMMANDS,
	PRINT_ONE_TIME_PASSWORD,
	GET_PLAYER_INFO,
	START_COLLECT_DEPOSIT_MONEY,
	FINISH_COLLECT_DEPOSIT_MONEY,
	GET_DEPOSIT_RECORDS,
	PRINT_DEPOSIT_TICKET_BY_ID,
	GET_WITHDRAWAL_REQUESTS,
	VALIDATE_WITHDRAWAL_PIN,
	PAY_WITHDRAWAL_REQUEST,
	CHECK_ONE_TIME_LOGIN,
	END_VERIFICATION_SESSION,
	GET_MERCHANT_INFO,
	SET_LAST_MONEY_INPUT_TYPE,
	SET_MONEY_INPUT_ACTIVE,
	INCREASE_LOCAL_BALANCE,
	SET_PLAYER_PAYMENT_INFO,
	GET_BET_PLAYER_PAYEMNT_INFO_BULK,
	RESET_PLAYER_PAYMENT_INFO,
	SAVE_PLAYER_PAYMENT_INFO,
	GET_SAVED_PLAYER_PAYMENT_INFO,
	PARTIAL_DEPOSIT_TO_CLIENT_ACCOUNT,
} from "../actions/actionTypes";
import IdleService from "@common/services/idle";
import { getPopupDispatchers } from "../contexts/popup";
import PaymentsService from "../services/payments";
import { TerminalBalanceFetcher } from "../helpers/terminalBalance";

const terminalMiddleWare = store => next => action => {
	const data = action?.payload;
	const openPopup = (...args) => {
		const { openPopup: openPopupHandler } = getPopupDispatchers();

		openPopupHandler?.(...args);
	};

	const closePopup = () => {
		const { closePopup: closePopupHandler } = getPopupDispatchers();

		closePopupHandler?.();
	};

	window.jsobject = window.jsobject || window.external || {};
	switch (action.type) {
		case SAVE_PLAYER_PAYMENT_INFO:
			window.jsobject.savePlayerPaymentInfo(JSON.stringify(data));
		case GET_SAVED_PLAYER_PAYMENT_INFO:
			window.jsobject.getSavedPlayerPaymentInfo();
			break;
		case GET_MERCHANT_INFO:
			window.jsobject.getMerchantInfo();
			break;
		case LOGIN_ADMIN:
			window.jsobject.loginAdmin(data.username, data.password);
			break;
		case PAY_CASINO_LOTTERY_WIN_TICKET:
			window.jsobject.titoAcceptCasinoBet(
				data.data.WinId.toString(),
				data.data.WinAmount,
				data.userData ? data.userData : null,
				0
			);
			break;
		case ADD_TO_BALANCE:
			const dataString = JSON.stringify(data);

			if (Config.main.usePayTicketNewMethod) window.jsobject.processBulkTitoOperation(dataString);
			else window.jsobject.bulkTitoOperation(dataString);
			break;
		case USER_DID_LOGIN:
			window.jsobject.userDidLogin(data.userId, data.currency);
			break;
		case USER_DID_LOGOUT:
			window.jsobject.userDidLogout();
			break;
		case REGISTER_MODE:
			window.jsobject.registerMode(data);
			break;
		case CONFIRM_REGISTRATION_NEW_CARD:
			window.jsobject.confirmRegistrationNewCard(data);
			break;
		case UPDATE_PLAYER_CARD_ID:
			window.jsobject.updatePlayerCardId(data);
			break;
		case TITO_ACCEPT_BET:
			window.jsobject.titoAcceptBet(
				data.barcode,
				data.amount,
				data.tax_amount,
				data.inputData ? data.inputData : null
			);
			break;
		// TODO delete after all partners get MultiplePopup
		case TITO_CASHOUT_BET:
			// if (Config.enableMultipleWinsPopup) {
				window.jsobject.titoCashoutBetFromTicketsBoard(
					data.barcode.toString(),
					data.amount,
					data.inputData ? data.inputData : null
				);
			// } else {
			// 	window.jsobject.titoCashoutBet(
			// 		data.barcode,
			// 		data.amount,
			// 		data.inputData ? data.inputData : null
			// 	);
			// }
			break;
		case GET_SUPERBET_TICKET_BY_ID:
			window.jsobject.getSuperbetTicketById(data);
			break;
		case SET_SUPERBET_ID:
			window.jsobject.setSuperBetId(data);
			break;
		case REJECT_SUPERBET:
			window.jsobject.rejectSuperbet(data);
			break;
		case SET_LANGUAGE:
			window.jsobject.setLanguage?.(data);
			break;
		case RESET_UI_BY_IDLE_TIMER:
			window.jsobject.resetUiByIdleTimer();
			break;
		case MOUSE_MOVE_POSITION:
			IdleService.resetTimer();
			TerminalBalanceFetcher.enablePolling();
			window.jsobject.touchPosition(data.x, data.y);
			break;
		case LOCK_TERMINAL:
			store.dispatch(
				SetTerminalPopupLauncher({
					terminalError: false,
					lockTerminal: true,
				})
			);
			openPopup(POPUPS.LOCK_TERMINAL, { data, disable: true });
			break;
		case UNLOCK_TERMINAL:
			if (store.getState().terminal.popupLauncher?.lockTerminal) {
				store.dispatch(SetTerminalPopupLauncher(null));

				closePopup();
			}
			break;
		case TERMINAL_ERROR:
			store.dispatch(
				SetTerminalPopupLauncher({
					terminalError: true,
					lockTerminal: false,
				})
			);
			openPopup(POPUPS.TERMINAL_ERROR, { data, disable: data.close });
			break;
		case HIDE_TERMINAL_ERROR:
			if (store.getState().terminal.popupLauncher.terminalError) {
				store.dispatch(SetTerminalPopupLauncher(null));
				closePopup();
			}
			break;
		case SEND_LOGS:
			window.jsobject.sendLogs(JSON.stringify(data));
			break;
		case CASHOUT_MONEY:
			window.jsobject.withdrawNew(1, Config.main.enableDigitalCashout);
			break;
		case PARTIAL_CASHOUT_MONEY:
			window.jsobject.withdrawPartialNew(1, data?.amount, Config.main.enableDigitalCashout);
			break;
		case CASHOUT_MONEY_CASH:
			window.jsobject.withdrawNew(2, Config.main.enableDigitalCashout);
			break;
		case CASHOUT_MONEY_WITH_FEE:
			window.jsobject.withdrawWithFee(2);
			break;
		case CASHOUT_CLIENT_MONEY:
			window.jsobject.withdrawClientBalance();
			break;
		case TITO_ACCEPT_CASHOUT:
			window.jsobject.titoAcceptCashout(data.barcode, data.balance);
			break;
		case SET_BALANCE:
			window.jsobject.setBalance(data);
			break;
		case PRINT_TICKET:
			window.jsobject.printTicket(data);
			break;
		case PRINT_BET_BUILDER_TICKET:
			window.jsobject.printBetBuilderTicket(data);
			break;
		case PRINT_CLIENT_TICKET:
			window.jsobject.printClientTicket(data);
			break;
		case PRINT_LOTTERY_TICKET:
			window.jsobject.printLotteryTickets(data, action.isCopy);
			break;
		case CASINO_GAMES_OPENED:
			window.jsobject.casinoGamesPageOpened();
			break;
		case PRINT_BOOKING_TICKET:
			window.jsobject.printBookingTicket(JSON.stringify(data));
			break;
		case UPPER_SCREEN:
			window.jsobject.upperScreen(
				`${data.type}${data.isNewStatistic ? "_PRO" : ""}`,
				data.id,
				data.videoURL,
				data.tv_type || 0
			);
			break;
		case SET_TAX:
			data.taxType && window.jsobject.setTax(data.taxType, data.taxPercent);
			break;
		case RFID_REGISTER_MODE:
			window.jsobject.rfidRegisterMode(action.mode, JSON.stringify(action.payload));
			break;
		case ADMIN_USER_COMMANDS:
			window.jsobject.adminUserCommands(action.command, JSON.stringify(action.payload));
			break;
		case DEPOSIT:
			window.jsobject.cardDeposit(action.payload);
			break;
		case DEPOSIT_TO_CLIENT_ACCOUNT:
			window.jsobject.depositToClientAccount(data.clientId.toString());
			break;
		case PARTIAL_DEPOSIT_TO_CLIENT_ACCOUNT:
			window.jsobject.partialDepositToClientAccount(data.clientId.toString(), data.amount);
			break;
		case PRINT_ONE_TIME_PASSWORD:
			window.jsobject.printOneTimePassword(action.payload);
			break;
		case GET_PLAYER_INFO:
			window.jsobject.getPlayerInfo(action.payload.id || "", action.payload.login || "");
			break;
		case START_COLLECT_DEPOSIT_MONEY:
			window.jsobject.startCollectDepositMoney();
			break;
		case FINISH_COLLECT_DEPOSIT_MONEY:
			window.jsobject.finishCollectDepositMoney();
			break;
		case GET_DEPOSIT_RECORDS:
			window.jsobject.getDepositRecords(action.payload.date);
			break;
		case PRINT_DEPOSIT_TICKET_BY_ID:
			window.jsobject.printDepositTicketById(action.payload.id);
			break;
		case GET_WITHDRAWAL_REQUESTS:
			window.jsobject.getWithdrawalRequests(action.payload.playerId);
			break;
		case VALIDATE_WITHDRAWAL_PIN:
			window.jsobject.validateWithdrawalPin(action.payload.pin, action.payload.id);
			break;
		case PAY_WITHDRAWAL_REQUEST:
			window.jsobject.payWithdrawalRequest(action.payload.requestId, action.payload.pin);
			break;
		case SET_LAST_MONEY_INPUT_TYPE:
			window.jsobject.setLastMoneyInputType(action.payload.data);
			break;
		case SET_MONEY_INPUT_ACTIVE:
			window.jsobject.manageMoneyInput(action.payload.data);
			break;
		case RESET_PLAYER_PAYMENT_INFO:
			window.jsobject.resetPlayerPaymentInfo();
			next(action);
			break;
		case SET_PLAYER_PAYMENT_INFO:
			window.jsobject.setPlayerPaymentInfo(
				JSON.stringify(action.payload || PaymentsService.getSessionBalanceEmptyState())
			);
			next(action);
			break;
		case GET_BET_PLAYER_PAYEMNT_INFO_BULK:
			window.jsobject.getBetPlayerPaymentInfoBulk(JSON.stringify(action.payload));
			break;
		case INCREASE_LOCAL_BALANCE:
			window.jsobject.increaseLocalBalanceOnNonCashInput(action.payload.data);
			break;
		case CHECK_ONE_TIME_LOGIN:
			window.jsobject.checkOneTimeLoginBarcode(action.payload);
			break;
		case END_VERIFICATION_SESSION:
			window.jsobject.endVerifiedLoginSession();
		default:
			next(action);
	}
};

export default terminalMiddleWare;
